<script setup>
import { withQuery } from "ufo";

const deleteDialog = ref(false);

definePage({
  meta: {
    layout: "default",
  },
});
const route = useRoute();
const router = useRouter();

const pageTitle = "Data Shop";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/shop",
  },
  {
    title: route.params.id,
    to: null,
  },
];

const { data: dataQuery } = await useApi(
  withQuery("/cms/shop/" + route.params.id, {
    method: "GET",
  })
);
const data = dataQuery ? dataQuery.value?.data : [];

// Use
const useItems = [
  {
    title: "Use",
    value: 0,
  },
  {
    title: "Not Use",
    value: 1,
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">{{ pageTitle }} Detail</h4>
  <VRow>
    <VCol class="align-items-stretch" cols="12" lg="12" sm="12">
      <VCard border class="v-card-data" title="Shop Information">
        <template #append>
          <VBtn
            :to="{ path: '/admin/shop/update/' + route.params.id }"
            block
            color="primary"
          >
            <VIcon icon="tabler-pencil" start />
            Edit {{ pageTitle }}
          </VBtn>
        </template>
        <VTable class="text-no-wrap" density="compact">
          <tbody>
            <tr>
              <td>Shop ID</td>
              <td>{{ data.id }}</td>
            </tr>
            <tr>
              <td>Shop Type</td>
              <td>{{ data.type }}</td>
            </tr>
            <tr>
              <td>Shop Name</td>
              <td>{{ data.name }}</td>
            </tr>
            <tr>
              <td>Phone number</td>
              <td>{{ data.phoneNumber }}</td>
            </tr>
            <tr>
              <td>Email address</td>
              <td>{{ data.email }}</td>
            </tr>
            <tr>
              <td>Shop name for receipt (line1)</td>
              <td>{{ data.nameForReceiptLine1 }}</td>
            </tr>
            <tr>
              <td>Shop name for receipt (line2)</td>
              <td>{{ data.nameForReceiptLine2 }}</td>
            </tr>
          </tbody>
        </VTable>
        <VDivider />
        <VCardText>
          <h6 class="text-h6">Role Option</h6>
        </VCardText>
        <VTable class="text-no-wrap" density="compact">
          <tbody>
            <tr>
              <td>Sales</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.sales == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Sales cancel</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.salesCancel == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Reload</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.reload == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Cancel reload</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.cancelReload == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Offline card issue by online</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.offlineCardIssueByOnline == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Offline card issue by offline</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.offlineCardIssueByOffline == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Online card issue</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.onlineCardIssue == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Hybrid card issue</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.hybridCardIssue == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
          </tbody>
        </VTable>
      </VCard>
      <div class="mx-auto text-center">
        <VBtn
          :to="{ path: '/admin/shop' }"
          class="mt-5 mx-auto text-center"
          color="secondary"
        >
          <VIcon icon="tabler-refresh" start />
          Back to {{ pageTitle }} List
        </VBtn>
      </div>
    </VCol>
  </VRow>
</template>
